<template>
  <div class="login-page">
    <b-row class="m-0 min-vh-100">
      <!-- Left Side - Branding -->
      <b-col lg="7" class="d-none d-lg-flex branding-side">
        <div class="branding-content">
          <div class="branding-header">
            <img src="@/assets/images/logo-salesflow.png" alt="Gildan" class="brand-logo-img" />
          </div>

          <div class="banner-showcase">
            <b-img
              fluid
              class="banner-image"
              src="@/assets/images/BANNER-B2B-MARCAS.png"
              alt="Banner B2B Marcas"
            />
          </div>

          <div class="branding-features">
            <div class="feature-item">
              <div class="feature-icon">
                <feather-icon icon="ShoppingBagIcon" size="20" />
              </div>
              <div class="feature-text">
                <h4>Catálogo Completo</h4>
                <p>Acesse todos os produtos das marcas Zorba, Hanes, Kendall e Tensor</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <feather-icon icon="TruckIcon" size="20" />
              </div>
              <div class="feature-text">
                <h4>Pedidos Simplificados</h4>
                <p>Faça pedidos de forma rápida e acompanhe em tempo real</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <feather-icon icon="BarChart2Icon" size="20" />
              </div>
              <div class="feature-text">
                <h4>Gestão Inteligente</h4>
                <p>Relatórios e análises para otimizar suas vendas</p>
              </div>
            </div>
          </div>
        </div>
      </b-col>

      <!-- Right Side - Login Form -->
      <b-col lg="5" class="d-flex align-items-center justify-content-center login-side">
        <div class="login-container">
          <!-- Mobile Logo -->
          <div class="mobile-logo d-lg-none">
            <img src="@/assets/images/logo-salesflow.png" alt="Gildan" class="brand-logo-mobile-img" />
          </div>

          <div class="login-header">
            <h2 class="login-title">Bem-vindo de volta</h2>
            <p class="login-subtitle">Acesse sua conta para continuar</p>
          </div>

          <validation-observer ref="loginValidation">
            <b-form class="login-form" @submit.prevent>
              <div class="form-group-custom">
                <label class="form-label-custom" for="login-email">Email</label>
                <validation-provider #default="{ errors }" name="Email" rules="required|email">
                  <div class="input-wrapper" :class="{ 'has-error': errors.length > 0 }">
                    <feather-icon icon="MailIcon" class="input-icon" />
                    <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false : null"
                      class="form-input-custom"
                      placeholder="seu@email.com"
                    />
                  </div>
                  <small class="error-text" v-if="errors[0]">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group-custom">
                <div class="label-row">
                  <label class="form-label-custom" for="login-password">Senha</label>
                  <b-link class="forgot-link" @click="esqueciSenha();">
                    Esqueceu a senha?
                  </b-link>
                </div>
                <validation-provider #default="{ errors }" name="Password" rules="required">
                  <div class="input-wrapper" :class="{ 'has-error': errors.length > 0 }">
                    <feather-icon icon="LockIcon" class="input-icon" />
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-input-custom"
                      :type="passwordFieldType"
                      placeholder="Digite sua senha"
                    />
                    <feather-icon
                      class="toggle-password"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </div>
                  <small class="error-text" v-if="errors[0]">{{ errors[0] }}</small>
                </validation-provider>
              </div>

              <div class="form-group-custom remember-row">
                <b-form-checkbox id="remember-me" v-model="status" class="custom-checkbox">
                  Manter-me conectado
                </b-form-checkbox>
              </div>

              <b-button type="submit" variant="primary" class="login-button" block @click="validationForm">
                Entrar
                <feather-icon icon="ArrowRightIcon" class="ml-2" />
              </b-button>
            </b-form>
          </validation-observer>

          <div class="login-footer">
            <p class="register-text">
              Quer cadastrar um cliente?
              <b-link :to="{ name: 'apps-pre-cadastro-cliente' }" class="register-link">
                Pré-Cadastro aqui
              </b-link>
            </p>
          </div>

          <div class="powered-by">
            <img src="@/assets/images/logo-salesflow.png" alt="Gildan" class="footer-logo-img" />
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Modal de seleção de perfil -->
    <b-modal ref="myModal" id="modal-default" ok-only ok-title="Entrar" @ok="logarPerfil()" centered
      title="Selecione seu perfil" modal-class="profile-modal">
      <b-card-text>
        <b-form-group label="Perfil de acesso" label-for="login-perfil">
          <b-form-select v-model="selected" :options="options" class="profile-select" />
        </b-form-group>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { useApi } from '@/composables/useApi';
import Store from '@/store';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import VuexyLogo from '@core/layouts/components/Logo.vue';
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue';
import { required, email } from '@core/utils/validations/validations';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { getHomeRouteForLoggedInUser } from '@/auth/utils';
import Swal from 'sweetalert2';
import useJwt from '@/auth/jwt/useJwt';
import Notifier from '@/libs/Notifier';
import axios from '@/libs/axios';
import InitialDataService from '@/services/InitialData.service';

const apiBack = useApi();
const notify = new Notifier();

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      password: '',
      userEmail: '',
      userDados: '',
      imagemLogin: {},
      logoImg: require('../../../public/logo.webp'),
      sideImg: require('@/assets/images/login.webp'),
      status: false,
      selected: null,
      options: [],
      // validation rulesimport store from '@/store/index'
      required,
      email,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/login.webp');
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  watch: {
    status(newStatus) {
      localStorage.setItem('rememberMe', newStatus);
      localStorage.setItem('email', this.userEmail);
      localStorage.setItem('password', this.password);
    },
  },

  mounted() {
    this.limparStorage();
    if (localStorage.getItem('rememberMe') === 'true') {
      this.status = JSON.parse(localStorage.getItem('rememberMe'));
      this.userEmail = localStorage.getItem('email');
      this.password = localStorage.getItem('password');
    } else if (localStorage.getItem('rememberMe') === 'false') {
      this.status = JSON.parse(localStorage.getItem('rememberMe'));
      this.userEmail = '';
      this.password = '';
    }
    const { segmento } = this.$route.params;
    if (segmento) {
      console.log('Segmento capturado:', segmento);
      axios.get(`/imagem-login/${segmento}`).then((response) => {
        console.log(response);
        this.imagemLogin = response.data;
      }).catch((error) => {
        console.error('Erro ao fazer requisição:', error);
      });
    } else {
      this.imagemLogin.url = require('@/assets/images/login.webp');
    }
  },
  methods: {
    async validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.loginInput();
        }
      });
    },
    async limparStorage() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
      localStorage.removeItem('userData');
      localStorage.removeItem('userPermissions');
      localStorage.removeItem('perfilLogado');
      localStorage.removeItem('lgn_admin');
      localStorage.removeItem('lgn_admin_metadata');
      localStorage.removeItem('infoPedidoForm');
      localStorage.removeItem('clienteData');
      localStorage.removeItem('representanteData');
    },
    async loginInput() {
      localStorage.setItem('rememberMe', this.status);
      localStorage.setItem('email', this.userEmail);
      localStorage.setItem('password', this.password);
      await this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          useJwt.login({
            usuario_email: this.userEmail,
            usuario_senha: this.password,
          })
            .then(async (response) => {
              this.userDados = response.data;
              const { userData } = response.data;

              if (userData.status === 0) {
                Swal.fire(
                  'Usuário bloqueado!',
                  `<div style="text-align: left; flex-wrap: nowrap"><p>Favor entrar em contato com a equipe DKP Sales</p>
<p>E-mail: <strong>financeiro@dkpsales.com</strong></p></div>`,
                  'error',
                );
              } else if (userData.perfils.length === 1) {
                console.log(userData, 'USERDATAPERFIL1');
                Store.commit('auth/SET_USER_AUTH', {
                  nome: userData.nome,
                  email: userData.email,
                  status: userData.status,
                });
                useJwt.setToken(response.data.accessToken);
                useJwt.setRefreshToken(response.data.refreshToken);
                localStorage.setItem('perfilLogado', JSON.stringify(userData.perfils[0]));
                localStorage.setItem('userData', JSON.stringify(userData));
                localStorage.setItem('userPermissions', JSON.stringify(userData.perfils[0].Permissoes));
                this.$ability.update(userData.perfils[0].Permissoes);

                if (userData.perfils[0].perfil_acesso_nome === 'ClienteFinal') {
                  localStorage.setItem('firstClickClienteFinal', 'true');
                } else {
                  localStorage.removeItem('firstClickClienteFinal');
                }

                this.gerenciarDadosInfoPedido(userData.id);

                Swal.fire({
                  title: 'Carregando dados iniciais...',
                  html: 'Aguarde enquanto carregamos seus dados.',
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                });

                await InitialDataService.loadInitialData();

                Swal.close();

                this.$router.replace(getHomeRouteForLoggedInUser(userData.perfils[0].perfil_acesso_nome));
                this.$store.commit('auth/SET_USER', this.userDados);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `Bem-vindo ${userData.nome}`,
                    icon: 'CoffeeIcon',
                    variant: 'success',

                  },
                },
                {
                  position: 'top-center',
                });
              } else if (userData.perfils.length > 1) {
                Store.commit('auth/SET_USER_AUTH', {
                  nome: userData.nome,
                  email: userData.email,
                  status: userData.status,
                });

                this.gerenciarDadosInfoPedido(userData.id);

                this.$refs.myModal.show();
                this.options = userData.perfils.map((perfil) => ({
                  text: perfil.perfil_acesso_nome,
                  value: perfil,
                }));
              }
            }).catch((error) => {
              notify.error('Email ou senha incorretos!');
            });
        }
      });
    },
    gerenciarDadosInfoPedido(userId) {
      try {
        const userPedidoKey = `infoPedidoForm_${userId || 'default'}`;
        const existingData = localStorage.getItem(userPedidoKey);

        if (existingData) {
          console.log('Dados antigos de InfoPedido encontrados. Reinicializando...');

          // Remover os dados antigos
          localStorage.removeItem(userPedidoKey);

          this.$store.dispatch('InfoPedido/resertInfoPedido');
        }
      } catch (error) {
        console.error('Erro ao gerenciar dados de InfoPedido:', error);
      }
    },
    async logarPerfil() {
      localStorage.setItem('perfilLogado', JSON.stringify(this.selected));
      this.$refs.myModal.hide();
      useJwt.setToken(this.userDados.accessToken);
      useJwt.setRefreshToken(this.userDados.refreshToken);
      localStorage.setItem('userData', JSON.stringify(this.userDados));
      localStorage.setItem('userPermissions', JSON.stringify(this.selected.Permissoes));
      this.$ability.update(this.selected.Permissoes);

      if (this.selected && this.selected.perfil_acesso_nome === 'ClienteFinal') {
        localStorage.setItem('firstClickClienteFinal', 'true');
      } else {
        localStorage.removeItem('firstClickClienteFinal');
      }

      Swal.fire({
        title: 'Carregando dados iniciais...',
        html: 'Aguarde enquanto carregamos seus dados.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await InitialDataService.loadInitialData();

      Swal.close();

      this.$router.replace(getHomeRouteForLoggedInUser(this.selected.perfil_acesso_nome));
      this.$store.commit('auth/SET_USER', this.userDados);

      this.$toast({
        component: ToastificationContent,
        props: {
          title: `Bem-vindo ${this.userDados.userData.nome}`,
          icon: 'CoffeeIcon',
          variant: 'success',

        },
      },
      {
        position: 'top-center',
      });
    },
    async esqueciSenha() {
      if (!this.userEmail) {
        notify.error('Preencha o campo email!');
        return;
      }

      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      localStorage.setItem('verifyEmail', this.userEmail);

      await axios.post('/seguranca/esqueciSenha', {
        usuario_email: this.userEmail,
      })
        .then((res) => {
          if (res.data.message === 'E-mail inválido') {
            notify.error(res.data.message);
          } else {
            notify.success('Email de redefinição enviado com sucesso!');
            this.$router.push({ name: 'forgot-password' });
          }
        })
        .catch((error) => {
          console.log('error', error);
          notify.error('Erro ao processar a solicitação. Tente novamente.');
        })
        .finally(() => {
          Swal.close();
        });
    },
  },
};
</script>

<style scoped lang="scss">
.login-page {
  min-height: 100vh;
  background: var(--sf-body-bg);
}

.branding-side {
  background: var(--sf-hero-bg);
  position: relative;
  overflow: hidden;
  padding: 3rem;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    opacity: 0.5;
  }
}

.branding-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
}

.branding-header {
  text-align: center;
  margin-bottom: 2rem;
}

.brand-logo {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.brand-logo-img {
  width: 240px;
  height: auto;
  filter: drop-shadow(0 4px 20px rgba(0, 0, 0, 0.3));
}

.footer-logo-img {
  width: 120px;
  height: auto;
  opacity: 0.7;
  transition: all 0.3s ease;

  &:hover {
    opacity: 1;
  }
}

.brand-logo-mobile-img {
  width: 200px;
  height: auto;
  filter: drop-shadow(0 4px 12px rgba(102, 126, 234, 0.3));
}

.brand-dkp {
  color: #ffffff;
  letter-spacing: 2px;
}

.brand-sales {
  color: #00d4ff;
  letter-spacing: 2px;
}

.brand-tagline {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.25rem;
  font-weight: 400;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.banner-showcase {
  margin: 2rem 0;
  display: flex;
  justify-content: center;
}

.banner-image {
  max-width: 100%;
  max-height: 35vh;
  object-fit: contain;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  transition: transform 0.4s ease;

  &:hover {
    transform: scale(1.02);
  }
}

.branding-features {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-top: 2rem;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: var(--sf-accent-bg);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;

  &:hover {
    background: var(--sf-accent-bg-hover);
    transform: translateX(5px);
  }
}

.feature-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, var(--sf-accent) 0%, var(--sf-accent-secondary) 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;
}

.feature-text {
  h4 {
    color: var(--sf-hero-title);
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }

  p {
    color: var(--sf-hero-subtitle);
    font-size: 0.85rem;
    margin: 0;
    line-height: 1.4;
  }
}

.login-side {
  background: var(--sf-card-bg);
  padding: 2rem;
}

.login-container {
  width: 100%;
  max-width: 400px;
  animation: slideInUp 0.6s ease-out;
}

.mobile-logo {
  text-align: center;
  margin-bottom: 2rem;
}

.brand-logo-mobile {
  font-size: 2rem;
  font-weight: 800;

  .brand-dkp {
    color: #1a1a2e;
  }

  .brand-sales {
    color: #667eea;
  }
}

.login-header {
  margin-bottom: 2rem;
}

.login-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--sf-text-primary);
  margin-bottom: 0.5rem;
}

.login-subtitle {
  color: var(--sf-text-muted);
  font-size: 1rem;
  margin: 0;
}

.login-form {
  margin-bottom: 1.5rem;
}

.form-group-custom {
  margin-bottom: 1.25rem;
}

.form-label-custom {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--sf-form-label);
  margin-bottom: 0.5rem;
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.forgot-link {
  font-size: 0.8rem;
  color: var(--sf-accent);

  &:hover {
    color: var(--sf-accent-dark);
    text-decoration: none;
  }
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--sf-form-bg);
  border: 2px solid var(--sf-form-border);
  border-radius: 10px;
  transition: all 0.3s ease;

  &:focus-within {
    border-color: var(--sf-form-focus-border);
    background: var(--sf-card-bg);
    box-shadow: var(--sf-form-focus-shadow);
  }

  &.has-error {
    border-color: var(--sf-btn-danger-bg);
  }
}

.input-icon {
  position: absolute;
  left: 1rem;
  color: var(--sf-form-placeholder);
  width: 18px;
  height: 18px;
  pointer-events: none;
}

.form-input-custom {
  border: none !important;
  background: transparent !important;
  padding: 0.875rem 1rem 0.875rem 3rem !important;
  font-size: 0.95rem;

  &:focus {
    box-shadow: none !important;
  }

  &::placeholder {
    color: var(--sf-form-placeholder);
  }
}

.toggle-password {
  position: absolute;
  right: 1rem;
  color: var(--sf-form-placeholder);
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: var(--sf-accent);
  }
}

.error-text {
  color: var(--sf-btn-danger-bg);
  font-size: 0.75rem;
  margin-top: 0.25rem;
  display: block;
}

.remember-row {
  margin-top: 1rem;
}

.custom-checkbox {
  font-size: 0.875rem;
  color: var(--sf-text-muted);
}

.login-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  padding: 0.875rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px;
  margin-top: 1rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--sf-shadow-md);
    background: linear-gradient(135deg, #556cd6 0%, #653d99 100%);
  }

  &:active {
    transform: translateY(0);
  }
}

.login-footer {
  text-align: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--sf-border-light);
}

.register-text {
  color: var(--sf-text-muted);
  font-size: 0.9rem;
  margin: 0;
}

.register-link {
  color: var(--sf-accent);
  font-weight: 600;

  &:hover {
    color: var(--sf-accent-dark);
    text-decoration: none;
  }
}

.powered-by {
  text-align: center;
  margin-top: 2rem;
  font-size: 0.8rem;
  color: var(--sf-text-muted);

  span {
    margin-right: 0.25rem;
  }
}

.powered-link {
  color: var(--sf-accent);
  font-weight: 500;

  &:hover {
    color: var(--sf-accent-dark);
    text-decoration: none;
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1200px) {
  .branding-side {
    padding: 2rem;
  }

  .brand-logo {
    font-size: 2.5rem;
  }

  .banner-image {
    max-height: 30vh;
  }
}

@media (max-width: 992px) {
  .login-side {
    padding: 2rem 1.5rem;
  }

  .login-container {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
  .login-title {
    font-size: 1.5rem;
  }

  .login-container {
    padding: 0 0.5rem;
  }
}

@media (max-height: 900px) {
  .branding-side {
    padding: 2rem;
  }
  .branding-header {
    margin-bottom: 1.5rem;
  }
  .banner-showcase {
    margin: 1.5rem 0;
  }
  .banner-image {
    max-height: 30vh;
  }
  .branding-features {
    margin-top: 1.5rem;
    gap: 1rem;
  }
  .login-header {
    margin-bottom: 1.5rem;
  }
  .form-group-custom {
    margin-bottom: 1rem;
  }
}

@media (max-height: 700px) {
  .branding-side {
    padding: 1.5rem;
  }
  .brand-logo-img {
    width: 180px;
  }
  .branding-header {
    margin-bottom: 1rem;
  }
  .banner-showcase {
    margin: 1rem 0;
  }
  .banner-image {
    max-height: 25vh;
  }
  .branding-features {
    margin-top: 1rem;
    gap: 0.75rem;
  }
  .feature-item {
    padding: 0.75rem;
  }
  .feature-icon {
    width: 36px;
    height: 36px;
  }
  .feature-text h4 {
    font-size: 0.9rem;
  }
  .feature-text p {
    font-size: 0.8rem;
  }

  .login-side {
    padding: 1rem;
  }
  .login-header {
    margin-bottom: 1rem;
  }
  .login-title {
    font-size: 1.5rem;
  }
  .form-group-custom {
    margin-bottom: 0.75rem;
  }
  .remember-row {
    margin-top: 0.5rem;
  }
  .login-button {
    padding: 0.75rem 1.5rem;
    margin-top: 0.75rem;
  }
  .login-footer {
    margin-top: 1rem;
    padding-top: 1rem;
  }
  .powered-by {
    margin-top: 1rem;
  }
}

</style>
